import React, { FC, ReactNode } from 'react';

import { Box } from '@mui/material';

import styled from '../../../styled';

interface CategoryLabelWrapperProps {
  bgColor?: string;
  className?: string;
  children: ReactNode;
}

const CategoryLabelWrapper: FC<CategoryLabelWrapperProps> = ({
  bgColor,
  className = '',
  children,
}) => {
  return (
    <CategoryLabel className={className} bgColor={bgColor}>
      {children}
    </CategoryLabel>
  );
};

export default CategoryLabelWrapper;

const CategoryLabel = styled(Box)`
  border-radius: 5px;
  background: ${({ bgColor }) => bgColor};
  padding: 4px 9px 5px;
  display: inline-flex;
  align-items: center;
`;
